import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

export const NotificationBannerContainer = styled.div`
    display: flex;
    justify-content: center;
    margin-top: -8px;
    margin-bottom: 24px;
    .alternative-notification-banner {
        max-width: 1320px;
        width: calc(100% - 134px);
        box-shadow: 0px 3px 6px 0px rgba(14, 30, 62, 0.08);
        padding-top: 14px;
        padding-bottom: 14px;
        p {
            font-weight: 400;
            color: ${colorsPalettes.carbon["400"]};
        }
        /* stylelint-disable-next-line selector-id-pattern */
        svg path#Group {
            fill: ${colorsPalettes.carbon["300"]};
        }
    }
`;
